module.exports = __webpack_public_path__ + "img/success_dog.a83bb063.png";